/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GeneratedNote } from '../models/generated-note';
import { GeneratedNotePagedList } from '../models/generated-note-paged-list';
import { retrieveNoteGenerated } from '../fn/information-messages/retrieve-note-generated';
import { RetrieveNoteGenerated$Params } from '../fn/information-messages/retrieve-note-generated';
import { searchNoteGenerated$Any } from '../fn/information-messages/search-note-generated-any';
import { SearchNoteGenerated$Any$Params } from '../fn/information-messages/search-note-generated-any';
import { searchNoteGenerated$Json } from '../fn/information-messages/search-note-generated-json';
import { SearchNoteGenerated$Json$Params } from '../fn/information-messages/search-note-generated-json';


/**
 * All about the configuration and retrieval of information messages
 */
@Injectable({ providedIn: 'root' })
export class InformationMessagesService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchNoteGenerated()` */
  static readonly SearchNoteGeneratedPath = '/custom/notes-generated/search';

  /**
   * search notes-generated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchNoteGenerated$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchNoteGenerated$Json$Response(params?: SearchNoteGenerated$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedList>> {
    return searchNoteGenerated$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * search notes-generated.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchNoteGenerated$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchNoteGenerated$Json(params?: SearchNoteGenerated$Json$Params, context?: HttpContext): Observable<GeneratedNotePagedList> {
    return this.searchNoteGenerated$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneratedNotePagedList>): GeneratedNotePagedList => r.body)
    );
  }

  /**
   * search notes-generated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchNoteGenerated$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchNoteGenerated$Any$Response(params?: SearchNoteGenerated$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedList>> {
    return searchNoteGenerated$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search notes-generated.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchNoteGenerated$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchNoteGenerated$Any(params?: SearchNoteGenerated$Any$Params, context?: HttpContext): Observable<GeneratedNotePagedList> {
    return this.searchNoteGenerated$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneratedNotePagedList>): GeneratedNotePagedList => r.body)
    );
  }

  /** Path part for operation `retrieveNoteGenerated()` */
  static readonly RetrieveNoteGeneratedPath = '/custom/notes-generated/{uid}';

  /**
   * retrieve single notes-generated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrieveNoteGenerated()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveNoteGenerated$Response(params: RetrieveNoteGenerated$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNote>> {
    return retrieveNoteGenerated(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieve single notes-generated.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retrieveNoteGenerated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveNoteGenerated(params: RetrieveNoteGenerated$Params, context?: HttpContext): Observable<GeneratedNote> {
    return this.retrieveNoteGenerated$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneratedNote>): GeneratedNote => r.body)
    );
  }

}
